import { h } from 'preact'
import cls from 'classnames'
import classes from './index.scss'
import { sanitize } from 'scripts/utils'

interface Props {
  content?: string
  className?: string
}

const FieldDescription = ({ content, className }: Props) => {
  if (!content) {
    return null
  }
  const safeHtml = sanitize(content)
  return <div className={cls(classes.fieldDesc, className)} dangerouslySetInnerHTML={{ __html: safeHtml }} />
}

export default FieldDescription
